import { useState, useMemo } from "react";
export const useRoleFilters = ({ roles }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredRoles = useMemo(() => {
    if (!searchTerm) {
      return roles;
    }

    const term = searchTerm.toLowerCase();
    return roles.filter((role) => {
      return (
        (role.name && role.name.toLowerCase().includes(term)) ||
        (role.id && String(role.id).toLowerCase().includes(term))
      );
    });
  }, [roles, searchTerm]);

  const noRoles = roles.length === 0;
  const noResults = roles.length > 0 && filteredRoles.length === 0;

  return {
    searchTerm,
    setSearchTerm,
    filteredRoles,
    noRoles,
    noResults,
  };
};

export default useRoleFilters;
